import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';
import Translate from '../../common/Translate';
import { STATUS as statusList, LOCALSTATUS as localStatusList } from '../../../config';

export const InspectionBadgeStatus = ({ status, localStatus, recordStatus }) => {
  const { to_send, sending, error_network, error_post_form } = localStatusList;

  let content = null;
  if (!status) return null;
  if (recordStatus === 3) return null;
  switch (status) {
    case statusList.appraisal_stopped:
      content = (
        <span className="badge badge-danger" data-cy="formBadge">
          <Translate code="appraisal_stopped" />
        </span>
      );
      break;
    case statusList.completed:
      if ([error_network, to_send, error_post_form].includes(localStatus)) {
        content = (
          <span className="badge badge-primary" data-cy="formBadge">
            <Spinner className="spinner-loader" />
            <Translate code="waiting_network" />
          </span>
        );
      }
      break;
    case statusList.submitted:
      if ([sending].includes(localStatus)) {
        content = (
          <span className="badge badge-primary" data-cy="formBadge">
            <Spinner className="spinner-loader" />
            <Translate code="submitting" />
          </span>
        );
      } else if ([error_network, to_send, error_post_form].includes(localStatus)) {
        content = (
          <span className="badge badge-primary" data-cy="formBadge">
            <Spinner className="spinner-loader" />
            <Translate code="waiting_network" />
          </span>
        );
      }
      break;
    default:
      break;
  }
  return <span>{content}</span>;
};

InspectionBadgeStatus.propTypes = {
  status: PropTypes.number,
  localStatus: PropTypes.number,
  recordStatus: PropTypes.number,
};

InspectionBadgeStatus.defaultProps = {
  status: null,
  localStatus: null,
  recordStatus: null,
};
